export default {
  testlet () {
    var a = []
    for (let i = 0; i < 10; i++) {
      a[i] = function () {
        console.log(i)
      }
    }
    a[0]()
  },
  testDestructuring () {
    var g = function ({addr}) {
      console.log(addr)
    }
    g({name: 678, addr: 'adc'})
  },
  testEnc () {
    console.log(window.Crypto)
    let text = "module.exports = {\
      caller: 'lope_webapp',\
      secretKey: '%TEer634affde98eJ$TG',\
      pid: 'utjgh4765ufgmbjiyo',\
      appId: 'com.lope.smartlife.miniprogram',\
      appName: '诺谱生活',\
      appVersion: '1.0.8',\
      salt: 'L0%TG_OKHR@W92kP',\
      isDebug: true\
    }"
    let salt = 'zzh'
    let cihperObj = window.Crypto.AES.encrypt(text, salt)
    console.log(typeof cihperObj)
    console.log(cihperObj)
    let x = cihperObj
    let res = window.Crypto.AES.decrypt(x, salt)
    console.log(res)
    // let ciphertext = window.Crypto.charenc.UTF8.bytesToString(cihperObj)
    // console.log(ciphertext)
  }
}



// WEBPACK FOOTER //
// ./src/test/es6test.js